import Plotly from "plotly.js-dist-min";

const DEFAULT_DELAYS_MS = [0, 150, 350];

function resizePlotlyElements() {
  if (typeof document === "undefined") return;

  const seen = new Set();
  document.querySelectorAll(".js-plotly-plot").forEach((el) => {
    if (!el || seen.has(el)) return;
    seen.add(el);

    if (!el._fullLayout && !el.querySelector?.(".plotly")) return;

    try {
      Plotly.Plots.resize(el);
    } catch {
      void 0;
    }
  });
}

/** Resize every Plotly chart after layout shifts (e.g. left/right sidebar toggle). */
export function resizeAllPlotlyCharts(options = {}) {
  const delays = options.delays ?? DEFAULT_DELAYS_MS;

  delays.forEach((delay) => {
    if (delay <= 0) {
      requestAnimationFrame(resizePlotlyElements);
    } else {
      setTimeout(resizePlotlyElements, delay);
    }
  });
}
